module.exports = __webpack_public_path__ + "img/badge-google-fr.db21e25b.svg";